import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { WorkspaceName } from "@components/workspace/WorkspaceName";
import { HStack } from "@design-system/HStack/HStack";
import { Tag } from "@design-system/Tag/Tag";
import { useIdCopy } from "@hooks/useIdCopy";
import { ClientDetailsRow } from "../clientViewConfig";
import styles from "../ClientsView.module.scss";

export const NameCell = ({
    row,
}: CellContext<ViewTableFeatures, ClientDetailsRow, string>) => {
    const { getCopyProps } = useIdCopy({ label: "Entity" });

    if (row.original.type === "entity") {
        return (
            <div className={styles.entityNameValue}>
                <EntityAvatar
                    size="xs"
                    entity={{
                        name: row.original.name,
                        iconColor: row.original.iconColor ?? "",
                        logo: row.original.logo ?? null,
                    }}
                    aria-hidden
                />
                <span
                    className={styles.nameValue}
                    {...getCopyProps(row.original.id)}
                >
                    {row.original.name}
                </span>
            </div>
        );
    }

    return (
        <HStack gap={8} align="center" className={styles.workspaceName}>
            <WorkspaceName
                workspace={{
                    id: row.original.id,
                    name: row.original.name,
                }}
                isIconVisible={false}
                className={styles.workspaceNameLabel}
                nameClassName={styles.nameValue}
            />
            {row.original.isFirmWorkspace && !row.original.isDemo && (
                <Tag color="neutral" outline>
                    Firm workspace
                </Tag>
            )}
        </HStack>
    );
};
